





















import DecisionStateTag from "./DecisionStateTag.vue";
import Vue from "vue";
import { Decision, DecisionState } from "@megarax/client/src/resources/Decision";
import VoteBadge from "@/components/VoteBadge.vue";
import { createComponent, computed } from "@vue/composition-api";
import { getResourceModule } from "@/apps/apps";

interface Props {
  value: Partial<Decision>;
}

export default createComponent<Props>({
  components: { VoteBadge, DecisionStateTag },
  name: "DecisionCardHeader",

  props: {
    value: {
      required: true,
      type: Object,
    },
  },
  setup(props, ctx) {
    const resourceModule = computed(() => {
      return getResourceModule(props.value.subjectApp!, props.value.subjectResource!);
    });

    const isAccepted = computed(() => props.value.state === DecisionState.accepted);
    const isRejected = computed(() => props.value.state === DecisionState.rejected);
    const isAwaiting = computed(() => props.value.state === DecisionState.awaiting);

    return { resourceModule, isAccepted, isRejected, isAwaiting };
  },
});
